
export function isInArray(array, value) {
    let found = false;
    for (let i = 0; i < array.length; i++) {
        if (array[i] === value) {
            found = true;
            break;
        }
    }
    return found;
}

export function isElementInViewport (el, autocomplete) {

    let rect = el.getBoundingClientRect();

    let height = (window.innerHeight || document.documentElement.clientHeight) + 50;
    if(autocomplete) height = height*1.33;
    return rect.bottom <= height; //150 wiggle room for mobile devices with nav bars or any other unconsidered items

}

export function scrollToElement(element, axis, duration, callback){

    // Lets ignore it for the moment.
    // const easeInCubic = (t)=>{ return t*t*t };
    // const easeInOut = (t)=>{ return t > 0.5 ? 4*Math.pow((t-1),3)+1 : 4*Math.pow(t,3) }
    // const easeOutCuaic = (t) => {  t--; return t*t*t+1; }
    const easeInOutQuad = (x) => { return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }
    // const eastInQuart = (x) => {return x * x * x * x;};

    const scrollStartPos = axis ==='y' ? element.parentNode.scrollTop : element.parentNode.scrollLeft;

    const scrollToElem = (startTime, currentTime, duration, scrollEndElemPos, startScrollOffset) => {
        const runtime = currentTime - startTime;
        let progress = runtime / duration;

        progress = Math.min(progress, 1);

        const ease = easeInOutQuad(progress);

        let x = axis === 'y' ? 0 : startScrollOffset + (scrollEndElemPos * ease);
        let y = axis !== 'y' ? 0 : startScrollOffset + (scrollEndElemPos * ease);

        if(axis === 'y') {
            element.parentNode.scrollTop = scrollStartPos + y;
        } else {
            element.parentNode.scrollLeft = scrollStartPos + x;
        }

        if(runtime < duration){
            requestAnimationFrame((timestamp) => {
                const currentTime = timestamp || new Date().getTime();
                scrollToElem(startTime, currentTime, duration, scrollEndElemPos, startScrollOffset);
            })
        } else {
            /** ANIMATION COMPLETE **/
            callback(element)

        }
    }


    const scrollEndElem = element;

    // 3. and well animate to that node..
    requestAnimationFrame((timestamp) => {
        const stamp = timestamp || new Date().getTime();
        const scrollDuration = duration || 500;
        const start = stamp;

        const startScrollOffset = axis === 'y' ? window.pageYOffset : window.pageXOffset;
        const scrollEndElemPos = axis === 'y' ? scrollEndElem.getBoundingClientRect().top : scrollEndElem.getBoundingClientRect().left;

        scrollToElem(start, stamp, scrollDuration, scrollEndElemPos, startScrollOffset);
    })

};


export function isIE(){
    if (/MSIE 10/i.test(navigator.userAgent)) {
        // This is internet explorer 10
        return true
    }

    if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
        // This is internet explorer 9 or 11
        return true
    }

    if (/Edge\/\d./i.test(navigator.userAgent)){
        // This is Microsoft Edge
        return true
    }
}


export function forceRedraw (){

    let n = document.createElement('div');
    document.body.appendChild(n);
    // n.style.display = 'none';

    setTimeout(()=>{
        n.parentNode.removeChild(n);
    },20); // you can play with this timeout to make it as short as possible
}

export function analyzeStack(location, order){

    let activeLocation = 0;
    Object.keys(order).forEach((key, index)=>{
        if(key === location) activeLocation = index;
    });

    let newStackOrder = { ...order };

    Object.keys(newStackOrder).forEach((key, index)=>{
        if(index === activeLocation - 1) newStackOrder[key] = 'prev';
        else if(index === activeLocation){
            newStackOrder[key] = 'active';
        }
        else if(index === activeLocation + 1) newStackOrder[key] = 'next';
        else newStackOrder[key] = '';
    });

    return newStackOrder;

}

export function chunkArray(myArray, chunk_size) {
    let index = 0;
    let arrayLength = myArray.length;
    let tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
        let myChunk = myArray.slice(index, index+chunk_size);
        tempArray.push(myChunk);
    }

    return tempArray;
}

export function buttonClick(e, fn){

    const keyD = e.key !== undefined ? e.key : e.keyCode;
    // e.key && e.keycode have mixed support - keycode is deprecated but support is greater than e.key
    // I tested within IE11, Firefox, Chrome, Edge (latest) & all had good support for e.key

    if ( (keyD === 'Enter' || keyD === 13) || (['Spacebar', ' '].indexOf(keyD) >= 0 || keyD === 32)) {
        // In IE11 and lower, e.key will equal "Spacebar" instead of ' '

        // Default behavior is prevented to prevent the page to scroll when "space" is pressed
        e.preventDefault();

        if(!fn) {
            e.currentTarget.click();
        } else {
            console.log('run')
            fn();

        }
    }
}